import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Features from "@/components/Features";
import Pricing from "@/components/Pricing";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import SampleMixesPage from "@/components/SampleMixesPage";
import { Toaster } from "@/components/ui/toaster";

const HomePage = () => {
  return (
    <>
      <Header />
      
      {/* Hero Section with Tagline */}
      <section className="pt-32 pb-20 bg-gradient-to-b from-black via-gray-900 to-black min-h-[60vh] flex items-center justify-center">
        <div className="container mx-auto px-4 text-center">
          <img 
            src="https://customer-assets.emergentagent.com/job_9e3d946b-1d38-4e27-976b-5f99d97c59df/artifacts/7kxjrt23_ChatGPT%20Image%20Jan%2014%2C%202026%20at%2009_53_39%20PM.png" 
            alt="Cheer Wave Productions" 
            className="w-80 h-80 md:w-[500px] md:h-[500px] mx-auto mb-8 object-contain logo-hero-3d"
          />
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            <span className="bg-gradient-to-r from-orange-400 via-red-400 to-yellow-400 bg-clip-text text-transparent">
              Professional Cheer Music Provider
            </span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto mb-8 leading-relaxed">
            Delivers high-quality cheer music at the most affordable prices and fastest turnaround.
          </p>
          <div className="flex flex-col items-center justify-center gap-2 text-gray-400 mb-4">
            <a href="mailto:info@cheerwaveproductions.com" className="hover:text-orange-400 transition-colors">
              info@cheerwaveproductions.com
            </a>
            <p className="text-gray-500 text-sm">Follow us @</p>
            <a href="https://www.instagram.com/cheerwaveproductions?igsh=MTNucWs1aWRheTFhZQ%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="hover:text-orange-400 transition-colors">
              @cheerwaveproductions
            </a>
          </div>
        </div>
      </section>

      <Features />
      <Pricing />
      <Contact />
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/sample-mixes" element={<SampleMixesPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;